/* PuraSIM — codigo global no critico, en un fichero que el navegador guarda (antes iba dentro de cada pagina).
   Se carga con defer: corre al terminar de leer la pagina, antes de DOMContentLoaded. 2026-10-01. */

/* 1. Ahrefs y Metricool tras load (antes en layout/theme.liquid) */
(function () {
        function cargar() {
          var a = document.createElement('script');
          a.async = true;
          a.src = 'https://analytics.ahrefs.com/analytics.js';
          a.setAttribute('data-key', '34xIDtVd/+lPH15T7buOtA');
          document.head.appendChild(a);
          var s = document.createElement('script');
          s.async = true;
          s.src = 'https://tracker.metricool.com/resources/be.js';
          s.onload = function () { try { if (typeof beTracker !== 'undefined') { beTracker.t({ hash: '6c8bae36c90549c6baa22b7e38b7ab22' }); } } catch (e) {} };
          document.head.appendChild(s);
        }
        function enOcio() {
          if ('requestIdleCallback' in window) requestIdleCallback(cargar, { timeout: 3000 });
          else setTimeout(cargar, 200);
        }
        if (document.readyState === 'complete') enOcio();
        else window.addEventListener('load', enOcio, { once: true });
      })();

/* 2. Calentado de fuentes del cajon y el popup (antes en layout/theme.liquid) */
(function () {
      var F = document.fonts;
      if (!F || !F.forEach) return;
      var LAT = /(^|,)\s*U\+2122\s*(,|$)/i, EXT = /(^|,)\s*U\+1D00-1DBF\s*(,|$)/i, PESO = /^([4-8]00|normal|bold)$/;
      function caras(fn) {
        F.forEach(function (f) {
          try { if (f.style === 'normal' && PESO.test(f.weight)) fn(f, f.family.replace(/["']/g, '')); } catch (e) {}
        });
      }
      function cargar(f) { if (f.status === 'unloaded') f.load().catch(function () {}); }
      function ext() { caras(function (f, fam) { if (fam === 'Inter' && EXT.test(f.unicodeRange)) cargar(f); }); }
      function ocio() {
        var ya = false, pop = !!document.getElementById('nr-pop');
        caras(function (f, fam) {
          if (fam === 'Inter' && EXT.test(f.unicodeRange) && f.status === 'loaded') ya = true;
          if ((fam === 'Inter' && LAT.test(f.unicodeRange)) || (pop && fam === 'Hanken Grotesk')) cargar(f);
        });
        if (ya) ext();
      }
      var EV = ['pointerover', 'pointerdown', 'focusin'];
      function intento(e) {
        var t = e.target;
        if (!t || !t.closest || !t.closest('header-drawer, dropdown-localization-component')) return;
        EV.forEach(function (n) { document.removeEventListener(n, intento, true); });
        ext();
      }
      function trasCarga() {
        EV.forEach(function (n) { document.addEventListener(n, intento, true); });
        if ('requestIdleCallback' in window) requestIdleCallback(ocio, { timeout: 4000 });
        else setTimeout(ocio, 1500);
      }
      if (document.readyState === 'complete') trasCarga();
      else window.addEventListener('load', trasCarga, { once: true });
    })();

/* 3. ps-attr: referido del comparador hasta el pedido (antes en snippets/ps-attr.liquid) */
(function () {
  'use strict';
  var API = "https://api.purasim.com";
  var PARAM = 's';
  var COOKIE = 'ps_attr';
  var BACKUP = 'ps_attr_bk';   // secondary storage only — eSIMDB does not accept it as the mechanism

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function source() {
    try { return new URLSearchParams(location.search).get(PARAM); } catch (e) { return null; }
  }

  // Strip the referral parameter so it never gets shared, indexed or bookmarked. The attribution
  // lives in the cookie from this point on — which is exactly what eSIMDB asks us to prove.
  function cleanUrl() {
    try {
      var u = new URL(location.href);
      if (!u.searchParams.has(PARAM)) return;
      u.searchParams.delete(PARAM);
      history.replaceState(null, '', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams : '') + u.hash);
    } catch (e) { /* older browser: leave the URL alone */ }
  }

  function claim(s) {
    return fetch(API + '/attr/click?s=' + encodeURIComponent(s) + '&lp=' + encodeURIComponent(location.pathname), {
      method: 'POST', credentials: 'include', keepalive: true
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  // Only touch the cart when the value actually changed: /cart/update.js is not free and this runs
  // on every page view.
  function syncCart(attr) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var current = cart && cart.attributes ? cart.attributes._ps_attr : null;
        var token = cart && cart.token;
        if (token) {
          fetch(API + '/attr/cart', {
            method: 'POST', credentials: 'include', keepalive: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ cart_token: token, attr: attr })
          }).catch(function () {});
        }
        if (current === attr) return;
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _ps_attr: attr, _ps_src: attr.split('.')[1] || '' } })
        }).catch(function () {});
      })
      .catch(function () {});
  }

  function run() {
    var s = source();
    var start = s ? claim(s).then(cleanUrl) : Promise.resolve();

    start.then(function () {
      var attr = cookie(COOKIE);

      // The cookie is gone but we saw it before: ask the Worker to re-issue it server-side rather
      // than writing one here, so the 30-day guarantee still holds. localStorage stays strictly a
      // backup, which is the only role eSIMDB's terms allow it.
      if (!attr) {
        var bk = null;
        try { bk = localStorage.getItem(BACKUP); } catch (e) {}
        if (bk && bk.indexOf('.') > 0) {
          return claim(bk.split('.')[1]).then(function () {
            var again = cookie(COOKIE);
            if (again) { try { localStorage.setItem(BACKUP, again); } catch (e) {} return syncCart(again); }
          });
        }
        return;
      }

      try { localStorage.setItem(BACKUP, attr); } catch (e) {}
      return syncCart(attr);
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
